import api from 'Api'
import { SET_MESSAGE } from '../components/utils'

const STRIPE_URL = '/payment/stripe/organization/'
const STRIPE_UNSUBSCRIBE_URL = '/payment/stripe/cancel/organization/'
const STRIPE_ALL_INVOICE_MOCK_URL = '/payment/stripe/invoice/all/organization/'
const STRIPE_UPCOMING_INVOICE_MOCK_URL = '/payment/stripe/invoice/organization/'
const STRIPE_SUBSCRIPTION_URL = '/payment/stripe/subscription/'
// const STRIPE_ADD_PAYMENT_URL = '/payment/stripe/'
const PAYMENT = '/payment/organization?organization_id='

const state = {
  paymentInformation: null,
  allInvoices: null,
  upcomingInvoices: null,
  subscriptionInfo: null,
  loading: false,
  card: {},
  latestPayment: {},
  billingInformation: {}
}

const getters = {
  paymentInformation: state => {
    return state.paymentInformation
  },
  billingInformation: state => {
    return state.billingInformation
  }
}

const actions = {
  async fetchPaymentData (context, organizationId) {
    try {
      if (organizationId) {
        const { data } = await api().get(PAYMENT + organizationId)
        context.commit('SET_PAYMENT_DATA', data)
      }
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  async getBillingInfo (context, organizationId) {
    try {
      const { data } = await api().get(STRIPE_URL + organizationId)
      context.commit('SET_PAYMENT_INFO', data)
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  async getAllInvoices (context, organizationId) {
    try {
      const { data } = await api().get(STRIPE_ALL_INVOICE_MOCK_URL + organizationId)
      context.commit('SET_ALL_INVOICE', data)
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  async getUpcomingInvoices (context, organizationId) {
    try {
      const { data } = await api().get(STRIPE_UPCOMING_INVOICE_MOCK_URL + organizationId)
      context.commit('SET_UPCOMING_INVOICE', data)
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  async getSubscriptionInfo (context, organizationId) {
    context.commit('SET_LOADING', { loading: true })
    try {
      const { data } = await api().get(STRIPE_SUBSCRIPTION_URL + organizationId)
      context.commit('SET_SUBSCRIPTION_INFO', data)
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    } finally {
      context.commit('SET_LOADING', { loading: false })
    }
  },
  async addPaymentMethod (context, payload) {
    const { typeMethod } = payload
    try {
      const paymentData = {
        payment_method_id: payload.payment_method_id
      }

      context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'entity_id' })
      // context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'card_info' })
      // context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'version' })
      // context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'quantity' })
      context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'name' })
      context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'phone' })
      context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'address' })
      context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'organization_id' })
      context.dispatch('addIfPresent', { payload, paymentData, typeProp: 'subscription_plan' })

      const { data } = await api()[typeMethod]('/payment/stripe', paymentData)
      if (data.error) {
        throw Error(data.error)
      } else {
        context.commit('SET_PAYMENT_METHOD_SUCCESS', data)
      }
      return data
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  async cancelSubscription ({ commit }, organizationId) {
    try {
      const { data } = await api().get(STRIPE_UNSUBSCRIBE_URL + organizationId)
      if (data.error) {
        SET_MESSAGE({ type: 'error', message: data.error })
      }
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  async changeSubscription (context, payload) {
    try {
      const paymentData = {
        payment_method_id: payload.payment_method_id,
        organization_id: payload.organization_id,
        subscription_plan: payload.subscription_plan
      }
      const { data } = await api().post('/payment/stripe', paymentData)
      if (data.error) {
        throw Error(data.error)
      } else {
        context.commit('SET_PAYMENT_METHOD_SUCCESS', data)
      }
      return data
    } catch (err) {
      SET_MESSAGE({ type: 'error', message: err.message })
    }
  },
  addIfPresent (context, payloadData, modifier) {
    if (payloadData.payload[payloadData.typeProp]) {
      if (modifier) {
        payloadData.paymentData[payloadData.typeProp] = modifier(payloadData.payload[payloadData.typeProp])
      } else {
        payloadData.paymentData[payloadData.typeProp] = payloadData.payload[payloadData.typeProp]
      }
    }
  }
}

const mutations = {
  SET_LOADING (context, payload) {
    context.loading = payload.loading
  },
  SET_PAYMENT_INFO (context, payload) {
    context.paymentInformation = payload
  },
  SET_PAYMENT_DATA (state, payload) {
    state.billingInformation = payload
  },
  SET_ALL_INVOICE (context, payload) {
    context.allInvoices = payload
  },
  SET_UPCOMING_INVOICE (context, payload) {
    context.upcomingInvoices = payload
  },
  SET_SUBSCRIPTION_INFO (context, payload) {
    context.subscriptionInfo = payload
  },
  SET_PAYMENT_METHOD_SUCCESS (context, payment) {
    state.card = payment.card_info
    state.latestPayment = payment

    if (payment.status === 'paid' || payment.status === 'active' || payment.status === 'trailing') {
      SET_MESSAGE({ type: 'success', message: 'Subscription Successful' })
    } else if (payment.status === 'incomplete') {
      SET_MESSAGE({ type: 'error', message: 'Subscription Failed' })
    } else {
      SET_MESSAGE({ type: 'success', message: 'Payment Method Saved' })
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'billingServices'
}
